import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Users,
  BarChart3,
  Shield,
  FileText,
  Download,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectContent, SelectItem } from "@/components/ui/select";

const SuperadminSidebar: React.FC = React.memo(() => {
  const location = useLocation();
  const navigate = useNavigate();

  const isCurrentPath = (path: string) => {
    return location.pathname === path;
  };

  // Mobile menu items
  const mobileMenuItems = [
    {
      value: "/superadmin",
      label: "Dashboard",
      icon: BarChart3,
    },
    {
      value: "/superadmin/users",
      label: "User Management",
      icon: Users,
    },
    {
      value: "/superadmin/consent-logs",
      label: "GDPR Logs",
      icon: FileText,
    },
    {
      value: "/superadmin/reports",
      label: "Reports",
      icon: Download,
    },
  ];
  const currentMobile = mobileMenuItems.find((item) => isCurrentPath(item.value)) || mobileMenuItems[0];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:block bg-white rounded-lg border border-gray-200 p-4">
        <div className="flex items-center gap-3 mb-4 px-4">
          <Shield className="h-4 w-4 text-primary" />
          <h1 className="font-bold text-xl">Superadmin</h1>
        </div>
        <div className="border-b border-gray-200 mb-4" />
        <nav className="space-y-2">
          <Button
            asChild
            variant={isCurrentPath("/superadmin") ? "default" : "ghost"}
            className="w-full justify-start"
          >
            <Link to="/superadmin">
              <BarChart3 className="mr-3 h-4 w-4" />
              Dashboard
            </Link>
          </Button>
          <Button
            asChild
            variant={isCurrentPath("/superadmin/users") ? "default" : "ghost"}
            className="w-full justify-start"
          >
            <Link to="/superadmin/users">
              <Users className="mr-3 h-4 w-4" />
              User Management
            </Link>
          </Button>
          <Button
            asChild
            variant={isCurrentPath("/superadmin/consent-logs") ? "default" : "ghost"}
            className="w-full justify-start"
          >
            <Link to="/superadmin/consent-logs">
              <FileText className="mr-3 h-4 w-4" />
              GDPR Logs
            </Link>
          </Button>
          <Button
            asChild
            variant={isCurrentPath("/superadmin/reports") ? "default" : "ghost"}
            className="w-full justify-start"
          >
            <Link to="/superadmin/reports">
              <Download className="mr-3 h-4 w-4" />
              Reports
            </Link>
          </Button>
        </nav>
      </div>

      {/* Mobile: Dropdown */}
      <div className="block md:hidden bg-white p-4 rounded-lg mb-4">
        <Select
          value={currentMobile.value}
          onValueChange={(val) => navigate(val)}
        >
          <SelectTrigger className="w-full">
            <div className="flex flex-row items-center gap-2">
              <currentMobile.icon className="h-4 w-4" />
              <span>{currentMobile.label}</span>
            </div>
          </SelectTrigger>
          <SelectContent className="w-full">
            {mobileMenuItems.map((item) => (
              <SelectItem key={item.value} value={item.value} className="py-3 data-[state=checked]:bg-gray-200 data-[state=checked]:text-gray-900">
                <span className="flex flex-row items-center gap-3 text-base">
                  <item.icon className="h-4 w-4 mr-2" />
                  <span className="whitespace-nowrap">{item.label}</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
});

export default SuperadminSidebar; 
